module.exports = __webpack_public_path__ + "static/media/mini.6d3e0f13.png";